//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/SelectSmartObject.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"AnchorLocation",1,0],[1,"AnchorLocator",0,"SelectSmartObject",0],[0,"CoordinateSystem",1,"CoordinateSystem",0],[1,"Height",0,"Expression",0],[1,"Length",0,"Expression",0],[0,"LockAspectRatio",1,0],[1,"Shear",0,"Expression",0],[0,"WScale",1,0]],[[[],"UpdateOnCoordinateSystem",{},0,0],[["origin","csys"],"EditCoordinateSystem",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.RectangularFrameBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.RectangularFrameBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.RectangularFrameBuilder.AnchorLocationType = Object.freeze({
    "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MiddleLeft" : "MiddleLeft", "MiddleCenter" : "MiddleCenter", "MiddleRight" : "MiddleRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

export default SPLM;